import { useEffect } from 'react'

interface DocumentMetaOptions {
  title: string
  description: string
  path?: string
}

const SITE_URL = 'https://alinova.co'
const SITE_NAME = 'Alinova'

function setMetaTag(attr: 'name' | 'property', key: string, content: string) {
  let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`)
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute(attr, key)
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', content)
}

function setLinkTag(rel: string, href: string) {
  let tag = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`)
  if (!tag) {
    tag = document.createElement('link')
    tag.setAttribute('rel', rel)
    document.head.appendChild(tag)
  }
  tag.setAttribute('href', href)
}

/**
 * Actualiza <title>, meta description, Open Graph/Twitter y el canonical
 * de forma dinámica por ruta, sin tocar ningún archivo HTML estático
 * (no existe un index.html editable en este proyecto) ni el contenido
 * visible de la página.
 */
export function useDocumentMeta({ title, description, path = '/' }: DocumentMetaOptions) {
  useEffect(() => {
    const fullTitle = title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`
    document.title = fullTitle

    setMetaTag('name', 'description', description)
    setMetaTag('property', 'og:title', fullTitle)
    setMetaTag('property', 'og:description', description)
    setMetaTag('property', 'og:type', 'website')
    setMetaTag('property', 'og:locale', 'es_CO')
    setMetaTag('property', 'og:site_name', SITE_NAME)
    setMetaTag('name', 'twitter:card', 'summary_large_image')
    setMetaTag('name', 'twitter:title', fullTitle)
    setMetaTag('name', 'twitter:description', description)

    const canonicalUrl = `${SITE_URL}${path}`
    setLinkTag('canonical', canonicalUrl)
    setMetaTag('property', 'og:url', canonicalUrl)
  }, [title, description, path])
}
